export default __webpack_public_path__ + "static/media/light_mode_tick_icon.0214f9e0.svg";